<style scoped lang="less">
.report-forms {
    width: 800px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid rgb(96, 139, 207);
    .line-1 {
        margin-bottom: 5px;
        width: 100%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .logo {
            width: 100px;
        }
        .today {
            font-size: 14px;
        }
    }
    .line-2 {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 18px;
        font-weight: bold;
        padding: 10px 0;
        background: rgb(96, 139, 207);
        border-left: 0.5px solid rgb(96, 139, 207);
        border-right: 0.5px solid rgb(96, 139, 207);
    }
    .line-3 {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(158, 191, 236);
        border-left: 0.5px solid rgb(96, 139, 207);
        border-right: 0.5px solid rgb(96, 139, 207);
    }
    .item1 {
        height: 100%;
        flex: 1;
        font-size: 14px;
        display: flex;
        font-weight: bold;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: 0.5px solid rgb(96, 139, 207);
    }
    .line-4 {
        width: 100%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 0.5px solid rgb(96, 139, 207);
        border-right: 0.5px solid rgb(96, 139, 207);
    }
    .item2 {
        height: 100%;
        flex: 1;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0.5px solid rgb(96, 139, 207);
    }
    .line-5 {
        width: 100%;
        display: flex;
        align-items: center;
        color: white;
        font-size: 14px;
        background: rgb(96, 139, 207);
        border-left: 0.5px solid rgb(96, 139, 207);
        border-right: 0.5px solid rgb(96, 139, 207);
        .item3 {
            padding: 10px;
        }
    }
}
.chart-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .myChart {
        width: 100%;
        height: 500px;
    }
}
</style>

<template>
    <div class="yb-container">
        <div class="chart-container" v-loading="loading">
            <div id="chart" class="myChart"></div>
        </div>
        <div class="report-forms" v-if="reportFormsData.length">
            <div class="line-1">
                <img class="logo" src="https://cdn.dhlz.com.cn/login/sh_logo.png">
                <div class="today">登记日期：{{today}}</div>
            </div>
            <div class="line-2">
                <div>甲醇市场动态</div>
            </div>
            <div class="line-3">
                <div class="item1" style="max-width:70px">地区</div>
                <div class="item1" v-for="item in reportFormsData[0].data">
                    <div v-for="it in calcDate(item.dateString)">{{it}}</div>
                </div>
                <div class="item1" style="max-width:70px">环比<br>昨日</div>
                <div class="item1" style="max-width:70px">同比<br>上周</div>
            </div>
            <div class="line-4" v-for="item in reportFormsData">
                <div class="item2" style="max-width:70px">{{item.areaString}}</div>
                <div class="item2" v-for="it in item.data">{{it.price}}</div>
                <div class="item2" style="max-width:70px" :class="calcLastPriceClass(item.data)">
                    {{calcLastPrice(item.data)}}</div>
                <div class="item2" style="max-width:70px" :class="calcFirstPriceClass(item.data)">
                    {{calcFirstPrice(item.data)}}</div>
            </div>
            <div class="line-5">
                <div class="item3">注：数据来自卓创资讯</div>
            </div>
        </div>
        <div class="line-container block-mini-top">
            <el-date-picker size="mini" v-model="date" align="right" type="date" placeholder="选择日期"
                :picker-options="pickerOptions" @change="allFetch">
            </el-date-picker>
            <el-button size="mini" class="margin-l" type="primary" @click.stop="allFetch">刷新</el-button>
            <el-button size="mini" class="margin-l" type="success" @click.stop="addOrEdit(null)">新增</el-button>
            <el-button size="mini" class="margin-l" type="warning" @click.stop="exportXlsx()">导出Excel</el-button>
            <el-button size="mini" class="margin-l" type="danger" v-if="isAdmin"
                @click.stop="spider()">{{spiderTxt}}</el-button>
            <!-- <el-upload class="margin-l" ref="upload" action="" :on-change="selectFile" :auto-upload="false"
                :show-file-list="false">
                <el-button size="mini" type="warning">upload</el-button>
            </el-upload> -->
        </div>

        <paged-table ref="table" @fetch-data="fetchData" class="block-mini-top">
            <el-table slot :data="data" border size="mini" :cell-style="$parent.$parent.cellStyle">
                <el-table-column label="日期" align="center" width="110">
                    <template slot-scope="scope">
                        {{scope.row.date | fmt-date}}
                    </template>
                </el-table-column>
                <el-table-column label="地区" align="center" width="120">
                    <template slot-scope="scope">
                        {{scope.row.area | fmt-sh-area}}
                    </template>
                </el-table-column>
                <el-table-column label="价格" align="center" prop="price" width="120"></el-table-column>

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button class="super-mini-button" type="primary" size="mini"
                            @click.stop="addOrEdit(scope.row)">编辑</el-button>
                        <el-button class="super-mini-button" type="danger" size="mini"
                            @click.stop="removeModel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </paged-table>

        <dialog-edit-s-h ref="edit" @fetch-data="allFetch"></dialog-edit-s-h>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http";

import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess } from "../util/toast";
import DialogEditSH from "../components/dialog/dialogEditSH.vue";
import * as xlsx from "xlsx";
import { exportExcel } from "../util/exportExcel";
import dayjs from "dayjs";
import { loginState } from "../util/login.js";
import * as echarts from "echarts";

export default {
    components: {
        PagedTable,
        DialogEditSH,
    },
    mixins: [],
    data() {
        return {
            reportFormsData: [],
            today: "",
            chart: null,
            data: [],
            keyword: "",
            date: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: "今天",
                        onClick(picker) {
                            picker.$emit("pick", new Date());
                        },
                    },
                    {
                        text: "昨天",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit("pick", date);
                        },
                    },
                    {
                        text: "一周前",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", date);
                        },
                    },
                ],
            },
        };
    },
    created() {
        this.reportForms();
        this.getChart();

        setTimeout(() => { }, 3000);
    },
    computed: {
        spiderTxt() {
            if (this.date) {
                return "爬取 " + dayjs(this.date).format("YYYY-MM-DD")
            } else {
                return "爬取 " + dayjs().format("YYYY-MM-DD")
            }
        },
        table() {
            return this.$refs.table;
        },
        edit() {
            return this.$refs.edit;
        },
        isAdmin() {
            if (loginState && loginState.admin) {
                if (loginState && loginState.admin.username == "tang") {
                    return true;
                }
                return loginState.admin.masterAdmin;
            } else {
                return false;
            }
        },
    },
    mounted() { },
    methods: {
        async exportXlsx() {
            let res = await HttpClient.post("/restful", {
                model: "SH",
                cond: {},
                sort: {
                    date: 1,
                },
                pageSize: 100000,
                pageNum: 0,
            });
            let data = res.result;
            let area = {
                taicang: "太仓",
                neimenggu: "内蒙古",
                guangdong: "广东",
                ningbo: "宁波",
                fujian: "福建",
                chuanyu: "川渝",
                shanxixian: "陕西",
                anhui: "安徽",
                hebei: "河北",
                lunan: "鲁南",
                lubei: "鲁北",
                shanxitaiyuan: "山西",
                hunan: "湖南",
                hubei: "湖北",
                henan: "河南",
                changzhou: "常州周边",
            };
            let list = data.map((it) => {
                return {
                    日期: it.date ? dayjs(it.date).format("YYYY-MM-DD") : "",
                    地区: it.area ? area[it.area] : "",
                    价格: it.price ? it.price : "",
                };
            });
            exportExcel(list, "各地区价格明细.xlsx");
        },
        async getChart() {
            let res = await HttpClient.post("/sh/chart");
            this.$nextTick(() => {
                this.drawLine(res);
            });
        },
        drawLine(_rawData) {
            if (!this.chart) {
                this.chart = echarts.init(document.getElementById("chart"));
            }
            const countries = [
                "太仓",
                "内蒙古",
                "广东",
                "宁波",
                "福建",
                "川渝",
                "陕西",
                "安徽",
                "河北",
                "鲁南",
                "鲁北",
                "山西",
                "湖南",
                "湖北",
                "河南",
                "常州周边",
            ];
            const datasetWithFilters = [];
            const seriesList = [];
            echarts.util.each(countries, function (country) {
                var datasetId = "dataset_" + country;
                datasetWithFilters.push({
                    id: datasetId,
                    fromDatasetId: "dataset_raw",
                    transform: {
                        type: "filter",
                        config: {
                            and: [{ dimension: "area", "=": country }],
                        },
                    },
                });
                seriesList.push({
                    type: "line",
                    datasetId: datasetId,
                    showSymbol: false,
                    name: country,
                    endLabel: {
                        show: true,
                        formatter: function (params) {
                            return params.value[1] + ": " + params.value[0];
                        },
                    },
                    labelLayout: {
                        moveOverlap: "shiftY",
                    },
                    emphasis: {
                        focus: "series",
                    },
                    encode: {
                        x: "date",
                        y: "price",
                        label: ["area", "price"],
                        itemName: "date",
                        tooltip: ["price"],
                    },
                });
            });
            this.chart.setOption({
                // animationDuration: 2000,
                dataset: [
                    {
                        id: "dataset_raw",
                        source: _rawData,
                    },
                    ...datasetWithFilters,
                ],
                title: {
                    text: "各地区甲醇价格",
                },
                tooltip: {
                    order: "valueDesc",
                    trigger: "axis",
                },
                xAxis: {
                    type: "category",
                    nameLocation: "middle",
                },
                yAxis: {
                    // name: "价格",
                    max: 3200,
                    min: 1400,
                },
                grid: {
                    right: 140,
                },
                series: seriesList,
            });
        },
        async allFetch() {
            this.refetchData();
            this.reportForms();
        },
        async spider() {
            await actionConfirm();
            let body = {}
            if (this.date) {
                body["date"] = dayjs(this.date).format("YYYY-MM-DD")
            }
            let res = await HttpClient.post("/sh/spider", body);
            this.allFetch();
        },
        //昨天
        calcLastPrice(data) {
            if (!data[data.length - 1].price || !data[data.length - 2].price) {
                return "-";
            }
            let price =
                data[data.length - 1].price - data[data.length - 2].price;
            if (price > 0) {
                return "+" + price;
            }
            return price;
        },
        //上周
        calcFirstPrice(data) {
            if (!data[data.length - 1].price || !data[0].price) {
                return "-";
            }
            let price = data[data.length - 1].price - data[0].price;
            if (price > 0) {
                return "+" + price;
            }
            return price;
        },
        //昨天
        calcLastPriceClass(data) {
            let price = this.calcLastPrice(data);
            if (price > 0) {
                return "color-danger fong-weight";
            } else if (price < 0) {
                return "color-success fong-weight";
            }
            return;
        },
        //上周
        calcFirstPriceClass(data) {
            let price = this.calcFirstPrice(data);
            if (price > 0) {
                return "color-danger fong-weight";
            } else if (price < 0) {
                return "color-success fong-weight";
            }
            return;
        },
        calcDate(item) {
            if (item.includes(" ")) {
                let arr = item.split(" ");
                return arr;
            } else {
                return [item];
            }
        },
        async reportForms() {
            this.reportFormsData = await HttpClient.post("/sh/reportForms", {
                date: this.date ? this.date : dayjs(),
            });
            this.today = dayjs(
                this.reportFormsData[0].data[
                    this.reportFormsData[0].data.length - 1
                ].dateString.split(" ")[0]
            ).format("YYYY年MM月DD日");
        },
        selectFile(file, fileList) {
            let fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    let data = ev.target.result;
                    let workbook = xlsx.read(data, {
                        type: "binary",
                    });
                    let lines = xlsx.utils.sheet_to_json(
                        workbook.Sheets[workbook.SheetNames[0]],
                        { header: 1 }
                    );
                    this.analyseData(lines);
                } catch (e) {
                    return;
                }
            };
            fileReader.readAsBinaryString(file.raw);
        },
        async analyseData(lines) {
            for (let i = 0; i < lines.length; i++) {
                const item = lines[i];
                let area = "";
                if (item[1] == "太仓") area = "taicang";
                if (item[1] == "内蒙古") area = "neimenggu";
                if (item[1] == "广东") area = "guangdong";
                if (item[1] == "宁波") area = "ningbo";
                if (item[1] == "福建") area = "fujian";
                if (item[1] == "川渝") area = "chuanyu";
                if (item[1] == "陕西") area = "shanxixian";
                if (item[1] == "安徽") area = "anhui";
                if (item[1] == "河北") area = "hebei";
                if (item[1] == "鲁南") area = "lunan";
                if (item[1] == "鲁北") area = "lubei";
                if (item[1] == "山西") area = "shanxitaiyuan";
                if (item[1] == "湖南") area = "hunan";
                if (item[1] == "湖北") area = "hubei";
                if (item[1] == "河南") area = "henan";
                if (item[1] == "常州周边") area = "changzhou";
                await HttpClient.put("/restful", {
                    model: "SH",
                    updates: {
                        date: dayjs(
                            item[0].replace(new RegExp("_", "g"), "-")
                        ).toDate(),
                        area,
                        price: item[2],
                    },
                });
                console.log("========", i);
            }
        },
        refetchData() {
            this.table.refetchData();
        },
        async fetchData() {
            let cond = {};
            if (this.keyword) {
                const regex = {
                    $regex: this.keyword,
                    $options: "i",
                };
                cond["$or"] = [
                    {
                        name: regex,
                    },
                    {
                        remarks: regex,
                    },
                ];
            }
            if (this.date) {
                cond["date"] = {
                    $gte: dayjs(this.date).startOf("day"),
                    $lte: dayjs(this.date).endOf("day"),
                };
            }
            let res = await HttpClient.post("/restful", {
                model: "SH",
                cond,
                sort: {
                    date: -1,
                },
                pageSize: this.table.pageSize,
                pageNum: this.table.pageNum,
                withCount: true,
            });
            this.data = res.result;
            this.table.submitTotal(res.count);
        },
        addOrEdit(item) {
            this.edit.addOrEdit(item);
        },
        async removeModel(item) {
            await actionConfirm();
            await removeModel("SH", item._id);
            msgSuccess();
            this.refetchData();
        },
    },
};
</script>
